import { render } from "./DeliveriesIndexPage.vue?vue&type=template&id=c4b899d6&scoped=true"
import script from "./DeliveriesIndexPage.vue?vue&type=script&lang=js"
export * from "./DeliveriesIndexPage.vue?vue&type=script&lang=js"

import "./DeliveriesIndexPage.vue?vue&type=style&index=0&id=c4b899d6&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b899d6"]])

export default __exports__